import { Layout } from 'antd'
import { Redirect, Route, Switch, useParams } from 'react-router-dom'

import UploadPackageHeader from './nav/UploadPackageHeader'
import SelectTagLayout from './progress/SelectTagLayout'
import UploadPackageConfirm from './progress/UploadPackageConfirm'
import UploadPackageInfoForm from './progress/UploadPackageInfoForm'
import UploadStickerWrapper from './progress/UploadStickerWrapper'
import rootHistory from '../../rootHistory'
import { usePackageInfo } from '../../hooks/reactQuery/usePackage'
import { useUserWithRedirect } from '../../hooks/user/useUserWithRedirect'
import { useIsMutating } from 'react-query'

import { makeDefaultPackageInfo } from '../../utils/makeDefaultPackageInfo'
import { useEveryStickerCategory } from '../../hooks/reactQuery/useEveryStickerCategory'
import { notiFormForError } from '../../components/notificationForm'
import { useIntl } from 'react-intl'
import Loading from '../../components/Loading'

export const packageUploadStageList = [
  'info',
  'sticker-upload',
  'select-tag',
  'confirm',
] as const
export default function UploadPackage() {
  const { packageId } = useParams<{ packageId: string }>()
  const user = useUserWithRedirect()
  const intl = useIntl()
  const {
    data: packageAndSticker,
    error: getPackageError,
    isLoading: getPackageLoading,
    isFetching: getPackageFetching,
  } = usePackageInfo(packageId, user?.sessionToken)
  const { isLoading: categoryLoading, error: categoryError } =
    useEveryStickerCategory()
  if (getPackageError || categoryError) {
    rootHistory.push('/')
    notiFormForError(
      intl.locale,
      intl.formatMessage({ id: 'Upload.packages.serverError' }),
    )
  }
  const isMutatingPackage = useIsMutating(packageId) > 0
  if (packageAndSticker && !getPackageFetching) {
    if (
      // 작성중인 것과 만드는중인 팩만 접근할수 있다.
      packageAndSticker.status !== 'editing' &&
      packageAndSticker.status !== 'creating'
    ) {
      rootHistory.push('/')
      return <></>
    }
  }

  return (
    <div className="upload-package-wrapper">
      <Loading
        isLoading={isMutatingPackage || getPackageLoading || categoryLoading}
      />
      {/* 밖의 history 변화를 감지하기 위한 컴포넌트 */}
      <Layout.Content style={{ margin: '20px 4px' }}>
        <Route
          path={`${'/upload'}/package/:packageId/:stage`}
          component={UploadPackageHeader}
        />

        <Switch>
          <Route
            path={`${'/upload'}/package/:packageId/${
              packageUploadStageList[0]
            }`}
            render={() => (
              <UploadPackageInfoForm
                packageAndSticker={
                  packageAndSticker
                    ? packageAndSticker
                    : makeDefaultPackageInfo({})
                }
              />
            )}
          />
          <Route
            path={`${'/upload'}/package/:packageId/${
              packageUploadStageList[1]
            }`}
            component={UploadStickerWrapper}
          />
          <Route
            path={`${'/upload'}/package/:packageId/${
              packageUploadStageList[2]
            }`}
            component={SelectTagLayout}
          />
          <Route
            path={`${'/upload'}/package/:packageId/${
              packageUploadStageList[3]
            }`}
            component={UploadPackageConfirm}
          />
          <Redirect
            to={`${'/upload'}/package/${packageId}/${
              packageUploadStageList[0]
            }`}
          />
        </Switch>
      </Layout.Content>
    </div>
  )
}
